import { BannerAndModalMessageConfigurationModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class BannerMessage extends DomainEntity<BannerAndModalMessageConfigurationModelDto> {
    public static from(dto: BannerAndModalMessageConfigurationModelDto): BannerMessage {
        return new BannerMessage(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get title() {
        return this.dto.title;
    }

    public set title(value: string) {
        this.dto.title = value;
    }

    public get description() {
        return this.dto.description ?? '';
    }

    public set description(value: string) {
        this.dto.description = value;
    }

    public get type() {
        return this.dto.type;
    }

    public set type(value: string) {
        this.dto.type = value;
    }

    public get status() {
        return this.dto.status;
    }

    public set status(value: string) {
        this.dto.status = value;
    }

    public get startDate() {
        return this.dto.startDate;
    }

    public set startDate(value: string) {
        this.dto.startDate = value;
    }

    public get endDate() {
        return this.dto.endDate;
    }

    public set endDate(value: string) {
        this.dto.endDate = value;
    }

    public get productTypeId() {
        return this.dto.productTypeId;
    }

    public set productTypeId(value: number) {
        this.dto.productTypeId = value;
    }

    public get productStatus() {
        return this.dto.productStatus;
    }

    public set productStatus(value: string) {
        this.dto.productStatus = value;
    }

    public get isActive() {
        return this.dto.status === 'Active';
    }
}
